import axios from "../../axios";
import store from "@/store/store.js";
const header = (token) => {
  return {
    headers: {
        Authorization: "Bearer "+ token
    }
  }
}

export default {
  async getAllTenants(token, filterUsers) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + `/api/tenant/${filterUsers}`;
    try {
      let tenants = await axios.get('', header(token));
      return tenants['data'];
    } catch (Exception) {
      throw Exception;
    }
  },
  async fetchPaginatedTenants(token, filterUsers, page = 1, limit = 4, search = '', sortName = 'id', sortType = 'DESC') {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + `/api/tenant/paginated`;
    try {
      return await axios.post('', {
        'filter_users': filterUsers,
        'pagination_page': page,
        'pagination_limit': limit,
        'search': search,
        'sort_name': sortName,
        'sort_type': sortType,
      }, header(token));
    } catch (Exception) {
      throw Exception;
    }
  },
  async addTenant(token, name, cnpj, features, template, pool, userLimit, plan, ticketLimit) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant';
    try {
      return await axios.post('', { 'name': name, 'cnpj': cnpj, 'features': features, 'template': template, 'pool': pool, 'userLimit': userLimit, 'plan': plan, 'ticketLimit': ticketLimit}, header(token));
    } catch (Exception) {
      throw Exception;
    }
  },
  async deleteTenant(hostnameId, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/delete';
    try {
      return await axios.post('', {'id': hostnameId}, header(token));
    } catch (Exception) {
      throw Exception;
    }
  },
  async getOrders(startAt, finishAt, byDay, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + `/api/tenant/sheets/orders?startAt=${startAt}&finishAt=${finishAt}&byDay=${byDay}`;
    try {
      return await axios.get('', header(token));
    } catch (Exception) {
      throw Exception;
    }
  },
  async getAttendances(startAt, finishAt, websiteId, estimation, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + `/api/tenant/sheets/attendances?startAt=${startAt}&finishAt=${finishAt}&websiteId=${websiteId}&estimation=${estimation}`;
    try {
      return await axios.get('', header(token));
    } catch (Exception) {
      throw Exception;
    }
  },
  async countPerPool(filterByEnvironment, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + `/api/countPerPool?filterByEnvironment=${filterByEnvironment}`;
    try {
      return await axios.get('', header(token));
    } catch (Exception) {
      throw Exception;
    }
  },
  async getInstanceLogs(startAt, finishAt, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + `/api/tenant/sheets/instance_logs?startAt=${startAt}&finishAt=${finishAt}`;
    try {
      return await axios.get('', header(token));
    } catch (Exception) {
      throw Exception;
    }
  },
  async getReasons(token, startAt, finishAt, tenancyId, reasonId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + `/api/tenant/sheets/reasons?startAt=${startAt}&finishAt=${finishAt}&tenancyId=${tenancyId}&reasonId=${reasonId}`;
    try {
      return await axios.get('', header(token));
    } catch (Exception) {
      throw Exception;
    }
  },
  async restoreTenant(hostnameId, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/restore';
    try {
      return await axios.post('', {'id': hostnameId}, header(token));
    } catch (Exception) {
      throw Exception;
    }
  },
  async updateTenantPlan(token, hostnameId, plan, user, ticket) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/set-plan';
    try {
      return await axios.post('', {'id': hostnameId, 'plan': plan, 'user': user, 'ticket': ticket}, header(token));
    } catch (Exception) {
      throw Exception;
    }
  },
  async getFeatures(tenantName, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/feature';
    try {
      return await axios.get('',  {
        params: {
          tenantName: tenantName
        },
        ...header(token)
      });
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async syncAnalytics(fromDate, toDate, forceUpdate, tenantName, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/syncAnalytics';
    try {
      return await axios.get('',  {
        params: {
          forceUpdate: forceUpdate,
          tenantName: tenantName,
          fromDate: fromDate,
          toDate: toDate,
        },
        ...header(token)
      });
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async updateFeatures(features, tenantName, token) {
    store.dispatch('setShowLoadingOverlay', false);
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/feature';
    try {
      const promises = [];
      Object.entries(features).forEach(([option, enabled]) => {
        const promise = axios.post(
          '',
          {option: option, enabled: enabled, tenantName: tenantName},
          header(token)
        );
        promises.push(promise);
      });

      const response = await Promise.all(promises);
      store.dispatch('setShowLoadingOverlay', true);
      return response;
    } catch (Exception) {
      throw Exception;
    }
  },
  async generateCampaignStatusWebhook(startAt, finishAt, type, tenant, token) {
    store.dispatch('setShowLoadingOverlay', false);
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/generate-campaign-status-webhook';
    try {
      const promises = [];
      Object.entries(type).forEach(([type, value]) => {
        if (value) {
          const promise = axios.get('',  {
            params: {
              tenantName: tenant,
              finishAt: finishAt,
              startAt: startAt,
              type: type
            },
            ...header(token)
          });
          promises.push(promise);
        }
      });

      const response = await Promise.all(promises);
      store.dispatch('setShowLoadingOverlay', true);
      return response;
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async generateAttendanceProductivityReport(fromDate, toDate, selectedUsers, email, tenantName, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/generate-attendance-productivity-report';
    try {
      return await axios.post('', {
        fromDate: fromDate,
        toDate: toDate,
        selectedUsers: selectedUsers,
        email: email,
        tenantName: tenantName
      }, header(token));
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async generateCampaignProductivityReport(fromDate, toDate, type, email, tenantName, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/generate-campaign-productivity-report';
    try {
      return await axios.post('', {
        fromDate: fromDate,
        toDate: toDate,
        type: type,
        email: email,
        tenantName: tenantName
      }, header(token));
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async generateOperatorProductivityReport(fromDate, toDate, selectedUsers, email, tenantName, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/generate-operator-productivity-report';
    try {
      return await axios.post('', {
        fromDate: fromDate,
        toDate: toDate,
        selectedUsers: selectedUsers,
        email: email,
        tenantName: tenantName
      }, header(token));
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async generateOrderProductivityReport(fromDate, toDate, email, tenantName, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/generate-order-productivity-report';
    try {
      return await axios.post('', {
        fromDate: fromDate,
        toDate: toDate,
        email: email,
        tenantName: tenantName
      }, header(token));
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async generateLoginFailuresProductivityReport(fromDate, toDate, selectedUsers, email, tenantName, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/generate-login-failures-productivity-report';
    try {
      return await axios.post('', {
        fromDate: fromDate,
        toDate: toDate,
        selectedUsers: selectedUsers,
        email: email,
        tenantName: tenantName
      }, header(token));
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async generateGradeProductivityReport(fromDate, toDate, selectedUsers, email, tenantName, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/generate-grade-report';
    try {
      return await axios.post('', {
        fromDate: fromDate,
        toDate: toDate,
        selectedUsers: selectedUsers,
        email: email,
        tenantName: tenantName
      }, header(token));
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async generateMariaProductivityReport(fromDate, toDate, selectedUsers, email, tenantName, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/generate-maria-report';
    try {
      return await axios.post('', {
        fromDate: fromDate,
        toDate: toDate,
        selectedUsers: selectedUsers,
        email: email,
        tenantName: tenantName
      }, header(token));
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async diagnoseInstance(instanceId, tenantName, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/diagnose-instance';
    try {
      return await axios.post('', {
        instanceId: instanceId,
        tenantName: tenantName
      }, header(token));
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async getCampaigns(type, page, limit, searchQuery, orderQuery, tenantName, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/get-campaigns';
    try {
      return await axios.post('', {
        type: type,
        page: page,
        limit: limit,
        searchQuery: searchQuery,
        orderQuery: orderQuery,
        tenantName: tenantName
      }, header(token));
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async restartCampaign(campaignId, minutes, messages, startAt, finishAt, tenantName, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/restart-campaign';
    try {
      return await axios.post('', {
        campaignId: campaignId,
        minutes: minutes,
        messages: messages,
        startAt: startAt,
        finishAt: finishAt,
        tenantName: tenantName
      }, header(token));
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async getFinishedTicketsRank(from, to, tenantName, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/get-finished-tickets-rank';
    try {
      return await axios.post('', {
        from: from,
        to: to,
        tenantName: tenantName
      }, header(token));
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async undoFinishedTickets(userId, from, to, tenantName, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/undo-finished-tickets';
    try {
      return await axios.post('', {
        userId: userId,
        from: from,
        to: to,
        tenantName: tenantName
      }, header(token));
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async getInstances(tenantName, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/get-instances';
    try {
      return await axios.get('',  {
        params: {
          tenantName: tenantName
        },
        ...header(token)
      });
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
}